import myAxios from "../utils/request";
export default {
  commit(params) {
    return myAxios.post("/api/User/GetToken", params);
  },
  verificationCode(params) {
    return myAxios.get(`/api/User/GetVerificationCode?pageId=${params}`);
  }
};
